export const COOKIE_NAMES = {
  clid: 'clid',
  googleAnalytics: '_ga',
  yandexAnalytics: '_ym_uid',
  partner: 'prc_osago',
  previousPartner: 'prc_osago_prev',
  partnerSetDate: 'prc_osago_setdate',
  promotion: 'int_ads',
  utm: '__utmz',
  previousUtm: '__utmz_prev',
  utmSetDate: '__utmz_setdate',
  isAlreadyFeedbackLeft: 'leftFeedback',
  lastFeedbackRate: 'lastFeedbackRate',
  mindboxDeviceUUID: 'mindboxDeviceUUID',
  shouldScrollInitiallyOnLanding: 'shouldScrollInitiallyOnLanding',
  intCross: 'int_cross',
  aspxAnonymous: '.ASPXANONYMOUS',
  partnerCreditSelection: 'prc_creditSelection',
  showRankingResponse: 'showRankingResponse',
  isMarketplace: 'isMarketplace',
} as const;

export const COOKIE_PARTNER_KEYS = [
  'aff_id',
  'p_offer_id',
  'source',
  'aff_sub',
  'aff_sub2',
  'aff_sub3',
  'aff_sub4',
  'aff_sub5',
  'tid',
] as const;

export const COOKIE_PARTNER_MAP_TO_FB = {
  aff_id: 'aff_id',
  p_offer_id: 'aff_offer_id',
  source: 'aff_source',
  tid: 'aff_tid',
} as const;
